import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse } from './ErrorResponse';
export class TemplateErrorResponse {
    existingTemplateId() {
        var _this_error_context;
        const id = (_this_error_context = this.error.context()) === null || _this_error_context === void 0 ? void 0 : _this_error_context.existingTemplateId;
        return typeof id === 'string' ? id : undefined;
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
